module.exports = __webpack_public_path__ + "img/muehlen.8e67b1fd.jpg";